/* global axios */
import WhatsAppSipApiClient from './index';

class WhatsAppSipTimeConditionsAPI extends WhatsAppSipApiClient {
  constructor() {
    super('time_conditions');
  }

  get(params) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${encodeURIComponent(id)}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.put(`${this.url}/${encodeURIComponent(id)}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${encodeURIComponent(id)}`);
  }

  getGroups() {
    return axios.get(`${this.url}/groups`);
  }
}

export default new WhatsAppSipTimeConditionsAPI();
